import { TableTextCell, TableUserListCell } from '../../Table'
import { UserMultiValuedList } from '../../User'
import { EpostValidationErrorsCell } from '../EpostValidationErrorsTable'

export function renderCell({
  TextCellAction,
  UserList = UserMultiValuedList,
  item,
  name,
  recipientCellProps,
  textCellProps,
  toPreparedUserValue,
  onClickTextCellAction,
  ...restProps
}) {
  const { [name]: value } = item

  switch (name) {
    case EpostValidationErrorsCell.Text:
      return (
        <TableTextCell
          {...restProps}
          textCellProps={{
            ...textCellProps,
            BeforeIcon: TextCellAction,
            beforeIconProps: { onClick: onClickTextCellAction },
          }}
          value={value}
        />
      )
    case EpostValidationErrorsCell.Recipient:
      return (
        <TableUserListCell
          List={UserList}
          count={item[EpostValidationErrorsCell.Count]}
          listProps={{
            ...recipientCellProps,
            errorId: item[EpostValidationErrorsCell.Code],
          }}
          value={toPreparedUserValue(
            value,
            item[EpostValidationErrorsCell.Count]
          )}
        />
      )
  }
}
